// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.with-error-text{color:#f44336}`, "",{"version":3,"sources":["webpack://./app/javascript/components/common/YesNoDescriptionInput/YesNoDescriptionInput.scss","webpack://./app/assets/stylesheets/clora-bootstrap-variables.scss"],"names":[],"mappings":"AACA,iBACE,aCiCiB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
